import React from 'react';
import styled from 'styled-components/macro';
// types
import { InteractiveCTAOption } from 'types';
// utils
import { onInteractiveCTAClick } from 'utils/helpers';
import { Backdrop } from './style';
import { useTranslation } from 'react-i18next';

const ButtonsWrapper = styled.div`
  padding: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

type CTAButtonProps = {
  marginTop?: string;
  padding?: string;
};

const CTAButton = styled.a<CTAButtonProps>`
  color: ${props => props.theme.colors.secondary[100]};
  background: ${props => props.theme.colors.white[100]};
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  opacity: 1 !important;
  min-width: 160px;
  height: 40px;
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  box-sizing: border-box;
  border-radius: 5px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: ${props => props.marginTop};
  padding: ${props => props.padding || '8px 16px 8px 8px'};
  white-space: nowrap;
  text-align: center;
`;

type Props = {
  interactiveCTAs: InteractiveCTAOption[];
  handleCloseModal: () => void;
  setShowCtaVideoModal: Function;
};

export const ContactInfoModal = ({
  handleCloseModal,
  interactiveCTAs,
  setShowCtaVideoModal,
}: Props) => {
  const { t } = useTranslation();
  if (!interactiveCTAs?.length) {
    return null;
  }
  return (
    <Backdrop style={{ zIndex: 14 }} onClick={handleCloseModal}>
      <ButtonsWrapper>
        {interactiveCTAs.map((button: any, i: number) => (
          <React.Fragment key={i}>
            <CTAButton
              onClick={() =>
                onInteractiveCTAClick(button, setShowCtaVideoModal)
              }
              key={i}
            >
              {button.label}
            </CTAButton>
          </React.Fragment>
        ))}
        <CTAButton
          key={'closeCTAButton'}
          onClick={handleCloseModal}
          marginTop={'8px'}
          padding={'8px'}
        >
          {t('Close')}
        </CTAButton>
      </ButtonsWrapper>
    </Backdrop>
  );
};
